import { useEffect, useState } from 'react';

import { Anchor, Box, Button, Group, Stack, Text } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';

import { TermsOfServiceModal } from '../TermsOfServiceModal';

import { COOKIE_BANNER_DISMISSED_KEY } from '@/utils/constant';

type CookieBannerProps = {
  bottomOffset?: string | number;
};

export const CookieBanner = ({ bottomOffset = 0 }: CookieBannerProps) => {
  const [showCookieBanner, setShowCookieBanner] = useState(false);
  const [opened, { open, close }] = useDisclosure(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    try {
      const dismissed = localStorage.getItem(COOKIE_BANNER_DISMISSED_KEY) === 'true';
      setShowCookieBanner(!dismissed);
    } catch (error) {
      console.error('Failed to check cookie banner dismissal:', error);
      // エラーが発生した場合は表示する（ユーザー体験を優先）
      setShowCookieBanner(true);
    }
  }, []);

  const handleDismiss = () => {
    try {
      localStorage.setItem(COOKIE_BANNER_DISMISSED_KEY, 'true');
      setShowCookieBanner(false);
    } catch (error) {
      console.error('Failed to save cookie banner dismissal:', error);
      // エラーが発生してもバナーは閉じる（ユーザー体験を優先）
      setShowCookieBanner(false);
    }
  };

  if (!showCookieBanner) {
    return null;
  }

  return (
    <>
      <Box
        sx={(theme) => ({
          position: 'fixed',
          bottom: bottomOffset,
          left: 0,
          right: 0,
          backgroundColor: '#f8f9fa',
          padding: '16px',
          zIndex: 1000,
        })}
      >
        <Stack spacing={8} px="40px">
          <Stack spacing={8}>
            <Text
              size="sm"
              sx={{
                color: '#78716c',
                fontSize: '14px',
                lineHeight: 1.5,
                fontWeight: 400,
                textAlign: 'center',
              }}
            >
              当ウェブサイトでは、利便性、品質維持・向上を目的に、クッキー（Cookie）を使用しています。{' '}
              <Anchor
                component="button"
                onClick={open}
                size="sm"
                c="primary"
                sx={{
                  color: '#0064be',
                  textDecoration: 'underline',
                  fontSize: '14px',
                  cursor: 'pointer',
                }}
              >
                詳細を見る
              </Anchor>
            </Text>
          </Stack>
          <Group position="right">
            <Button variant="outline" radius="xl" onClick={handleDismiss} size="xs">
              閉じる
            </Button>
          </Group>
        </Stack>
      </Box>
      <TermsOfServiceModal opened={opened} onClose={close} hideAcceptButton />
    </>
  );
};
